import { useContext } from "react";
import { Divider, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";
import moment from "moment";

//import utils
import { formatPersianDate } from "../../../../utils/date";
import { numberWithCommas } from "../../../../utils/utility";

//import images and icons
import flightArrowIcon from "../../../../assets/icons/flight-line.svg";

function FlightConfirm({ selectedFlight, newPrice, isTwoWay }) {
    //general variables
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    const informationList = [
        { id: 1, title: t("flightType"), value: locale === "en" ? selectedFlight?.type : selectedFlight?.persianType },
        { id: 2, title: t("flightNumber"), value: selectedFlight?.flightNumber },
        { id: 3, title: t("aircraft"), value: selectedFlight?.aircraft },
        { id: 4, title: t("class"), value: selectedFlight?.class },
        { id: 5, title: t("baggage"), value: selectedFlight?.baggage },
        { id: 6, title: t("flightClass"), value: locale === "en" ? selectedFlight?.cabin : selectedFlight?.cabinPersian },
        { id: 7, title: t("price"), value: `${numberWithCommas(newPrice || selectedFlight?.totalPrice)} ${t("currency")}` },
    ];

    //format date in Persian format
    const formatDate = date => {
        return formatPersianDate(date, {
            day: "numeric",
            month: "long",
            year: undefined,
            weekday: "long",
        });
    };

    return (
        <Grid container item xs={12} rowGap={2}>
            <Grid className="confirm__flight" container item xs={12} columnGap={2}>
                <Grid component="img" src={flightArrowIcon} container item xs="auto" />
                <Grid container item xs={4} direction="column" justifyContent="space-between">
                    <Grid container item xs="auto" direction="column">
                        <span>{selectedFlight?.departureTime}</span>
                        <span>
                            {locale === "fa" ? formatDate(selectedFlight?.departureDate) : moment(selectedFlight?.departureDate).format("ddd D MMM")}
                        </span>
                    </Grid>
                    <Grid container item xs="auto" direction="column">
                        <span>{selectedFlight?.destinationTime}</span>
                        <span>
                            {locale === "fa" ? formatDate(selectedFlight?.arrivalDate) : moment(selectedFlight?.arrivalDate).format("ddd D MMM")}
                        </span>
                    </Grid>
                </Grid>
                <Grid container item xs={6} direction="column" justifyContent="space-between">
                    <span>
                        {locale === "en" ? selectedFlight?.departureEnName : selectedFlight?.departureFaName} ({selectedFlight?.departureIata})
                    </span>
                    <span>
                        {locale === "en" ? selectedFlight?.destinationEnName : selectedFlight?.destinationFaName} ({selectedFlight?.destinationIata})
                    </span>
                </Grid>
            </Grid>

            <Grid className="confirm" container item xs={12}>
                <Grid className="confirm__title" container item xs={12}>
                    {t("airline")} {locale === "en" ? selectedFlight?.airline : selectedFlight?.airlinePersian}
                </Grid>

                <Divider width="100%" />

                <Grid className="confirm__information" container item xs={12} rowGap={2}>
                    {informationList.map(information => {
                        if (!!isTwoWay && information.id === 7) return null;

                        return (
                            <Grid container item xs={4} direction="column">
                                <span className="confirm__label">{information.title}</span>
                                <span className="confirm__value">
                                    <bdi>{information.value}</bdi>
                                </span>
                            </Grid>
                        );
                    })}
                </Grid>
            </Grid>
        </Grid>
    );
}

export default FlightConfirm;
